export var CommentEditorSource;
(function(CommentEditorSource) {
    /** The user intends to post a comment at the root level of an item. */ CommentEditorSource["Independent"] = "independent";
    /** The user intends to reply to a comment that already exists. */ CommentEditorSource["Reply"] = "reply";
    /** The user is editing an existing comment. */ CommentEditorSource["Edit"] = "edit";
})(CommentEditorSource || (CommentEditorSource = {}));
export var RequestError;
(function(RequestError) {
    RequestError[RequestError["GeneralError"] = 0] = "GeneralError";
})(RequestError || (RequestError = {}));

//# sourceMappingURL=types.js.map